import script from "./EbooksCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./EbooksCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./EbooksCarousel.vue?vue&type=style&index=0&id=f948e5b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f948e5b8"]])

export default __exports__